import { useEffect } from 'react';

export const usePageTitle = (title: string) => {
  useEffect(() => {
    const originalTitle = document.title;
    document.title = `${title} | BizMatch`;
    
    return () => {
      document.title = originalTitle;
    };
  }, [title]);
};

export const setPageTitle = (title: string) => {
  document.title = `${title} | BizMatch`;
};